/* eslint-disable */
import { image } from '~/js/utils/image';


/**
* Build Article HTML
* @param {Object} article
*/
export function buildArticleItem(article, origin) {
  const createdAt = () => {
    if (origin !== 'ledige-stillinger') {
      return `
        <p class="article-item__date">
          ${ article.created_at }
        </p>
      `
    } else return ''
  }

  const buildCard = () => `
    <a href="${ article.url }" class="article-item">
      <div class="article-item__image aspect-ratio aspect-ratio--3/2">
        ${ image({src: article.image, alt: '', width: 500, height: 500}) }
      </div>
      
      ${createdAt()}

      <h3 class="article-item__title">
        ${ article.title }
      </h3>

      <p class="article-item__excerpt">
        ${ article.excerpt }
      </p>

      <span class="article-item__button button button--primary">
        ${ article.read_more_translation }
      </span>
    </a>
  `;

  return buildCard();
}